import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { IonButton, IonCol, IonGrid, IonIcon, IonRow, ModalController } from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';
import { EAvailabilityState, EFreightForCarrierStatus } from '@okcargo-apps/shared-domain';
import { FreightAvailableAcceptModalComponent } from '../freight-available-accept-modal/freight-available-accept-modal.component';
import { FreightAvailableInterestedModalComponent } from '../freight-available-interested-modal/freight-available-interested-modal.component';
import { IFreightAvailableDetailedVM } from '../freight-available-store.model';

@Component({
  selector: 'lib-freight-available-detail-footer-buttons',
  templateUrl: './freight-available-detail-footer-buttons.component.html',
  styleUrls: ['./freight-available-detail-footer-buttons.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [IonIcon, IonButton, IonCol, IonRow, IonGrid, TranslateModule],
})
export class FreightAvailableDetailFooterButtonsComponent {
  public readonly itemVM = input.required<IFreightAvailableDetailedVM>();

  // private readonly loadingCtrl = inject(LoadingController);
  private readonly modalCtrl = inject(ModalController);
  // private readonly translate = inject(TranslateService);
  // private readonly messagesService = inject(MessagesUiService);
  // private readonly analyticsService = inject(AnalyticsService);

  // private readonly freightAvailableMutationsService = inject(FreightAvailableMutationsService);

  protected readonly freightAvailable = computed(() => this.itemVM().item);
  protected readonly isLoading = computed(() => this.itemVM().isLoading);
  protected readonly hasError = computed(() => this.itemVM().error);
  protected readonly actionsDisabled = computed(() => this.itemVM().actionsDisabled);

  protected readonly isFullyAvailable = computed(() => {
    return this.freightAvailable()?.available === EAvailabilityState.FULL;
  });

  protected readonly isAvailableWithConditions = computed(() => {
    return this.freightAvailable()?.available === EAvailabilityState.PARTIAL;
  });

  protected readonly isNotAvailable = computed(() => {
    return this.freightAvailable()?.available === EAvailabilityState.NO;
  });

  public EFreightStatus = EFreightForCarrierStatus;

  public readonly freightAccepted = output<string>();

  public async acceptAvailableFreight(): Promise<void> {
    const freightId = this.freightAvailable()?.id;

    if (!freightId) {
      return;
    }

    const modal = await this.modalCtrl.create({
      component: FreightAvailableAcceptModalComponent,
      componentProps: {
        freight: this.freightAvailable(),
      },
      backdropDismiss: false,
    });

    await modal.present();

    const { role, data } = await modal.onWillDismiss<string>();

    if (role === 'confirm' && data) {
      this.freightAccepted.emit(data);
    }
  }

  async showInterestOnAssignedFreight(): Promise<void> {
    const freightId = this.freightAvailable()?.id;

    if (!freightId) {
      return;
    }

    const modal = await this.modalCtrl.create({
      component: FreightAvailableInterestedModalComponent,
      componentProps: {
        freight: this.freightAvailable(),
      },
      backdropDismiss: false,
    });
    modal.present();
  }
}
